import { useEffect, useState } from 'react'
import { supabase } from "../utils/supabase"
import UserDashboard from "./UserDashboard"
import MerchantDashboard from "./MerchantDashboard"
import { Box } from '@mui/material'
import { L } from '../components/ui/LavDropdown'

function DashboardRouter() {
	const [loading, setLoading] = useState(true)
	const [role, setRole] = useState(null)

	useEffect(() => {
		let mounted = true
		const load = async () => {
			const { data } = await supabase.auth.getSession()
			const userId = data.session?.user?.id
			if (!userId) {
				window.location.assign('/login')
				return
			}
			const { data: profile } = await supabase
				.from('profiles')
				.select('role')
				.eq('id', userId)
				.maybeSingle()
			if (!mounted) return
			console.log(userId)
			console.log(profile)
			setRole(profile?.role || null)
			setLoading(false)
		}
		load()
		return () => { mounted = false }
	}, [])

	if (loading) {
		return (
			<Box sx={{
				minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
				p: '16px', bgcolor: L.bg, fontFamily: L.font,
			}}>
				<Box sx={{
					width: '100%', maxWidth: 380, bgcolor: '#FFFFFF', border: `1px solid ${L.border}`,
					borderRadius: '18px', boxShadow: '0 12px 40px rgba(46, 42, 64, 0.08)',
					p: '32px 28px', display: 'flex', flexDirection: 'column', alignItems: 'center',
					textAlign: 'center', gap: '18px',
				}}>
					<Box sx={{
						width: 46, height: 46, borderRadius: '50%',
						border: `3px solid ${L.primarySoft}`, borderTopColor: L.primary,
						'@keyframes drSpin': { to: { transform: 'rotate(360deg)' } },
						animation: 'drSpin 0.8s linear infinite',
						'@media (prefers-reduced-motion: reduce)': { animation: 'none' },
					}} />
					<Box>
						<Box sx={{ fontSize: '17px', fontWeight: 750, letterSpacing: '-0.01em', color: L.text }}>
							Loading your dashboard
						</Box>
						<Box sx={{ mt: '5px', fontSize: '13.5px', fontWeight: 550, color: L.muted }}>
							Fetching your account…
						</Box>
					</Box>
				</Box>
			</Box>
		)
	}

	if (role === 'merchant_owner') return <MerchantDashboard />
	return <UserDashboard />
}

export default DashboardRouter 